import messageResource from '../../messageResource'
import {CURRENT_PRODUCT} from '../../constants'

export const DROPZONE_PARAMETERS = {
    url: '#',
    maxFilesize: 5, //MB
    dictResponseError: messageResource.getMessage('error.js.json_rpc.network_error', [CURRENT_PRODUCT]),
    dictMaxFilesExceeded: messageResource.getMessage('common.multiple_upload_error'),
    dictFileTooBig: messageResource.getMessage('logo_settings.dropzone.file_too_big_error'),
    acceptedFiles: '.gif, .png, .jpeg, .jpg',
}


// WEBPACK FOOTER //
// ./web/js/administration/customization/constants.js